export default __webpack_public_path__ + "static/list-2106fac595da9094a50c6bf214857a13.jpg";